import React, { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Button } from "../../../../ui";
import { Actions } from "./ui-pending";
import "./detuctedFile.scss";

const DeductedClassDetails: React.FC = () => {
    const [selectedDates, setSelectedDates] = useState<[DateObject | null, DateObject | null]>([null, null]);

    const handleDateChange = (dates: (DateObject | null)[]) => {
        if (dates.length === 2 && dates[0] && dates[1]) {
            setSelectedDates([dates[0], dates[1]]);
        }
    };

    const handleSubmit = () => {
        const [fromDateObj, toDateObj] = selectedDates;

        if (fromDateObj && toDateObj) {
            const fromDate = fromDateObj.format("YYYY-MM-DD");
            const toDate = toDateObj.format("YYYY-MM-DD");

            console.log("Submitting date range:", { fromDate, toDate });
        } else {
            console.error("Please select a valid date range.");
        }
    };

    return (
        <div className="ds-stack deducted-classes">
            <div className="ds-field">
                <label className="ds-field__label" htmlFor="deducted-classes-range">Date range</label>
                <DatePicker
                    id="deducted-classes-range"
                    placeholder="Pick a date range"
                    inputClass="ds-input"
                    containerClassName="deducted-classes__picker"
                    value={selectedDates}
                    onChange={(dates) => handleDateChange(dates as DateObject[])}
                    range
                    format="YYYY-MM-DD"
                />
            </div>

            <Actions align="start">
                <Button variant="primary" onClick={handleSubmit}>
                    Submit
                </Button>
            </Actions>
        </div>
    );
};

export default DeductedClassDetails;
